import React from "react";
import styled from "styled-components";

const TruncatedContainer = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  position: relative;
  width: 100%;
  display: inline-block;
  min-width: 0;
  flex: 1;

  &:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    left: 0;
    top: 100%;
    background-color: #333;
    color: white;
    padding: 5px;
    border-radius: 3px;
    z-index: 1;
    white-space: normal;
    max-width: 300px;
    word-wrap: break-word;
  }
`;

/**
 * A component that truncates text and shows the full text in a tooltip on hover
 * @param {Object} props - Component props
 * @param {string} props.text - The text to display
 * @param {number} props.maxLength - Optional maximum length before truncation
 * @param {React.ReactNode} props.children - Optional children to render instead of text
 * @returns {React.ReactElement} - The truncated text component
 */
const TruncatedText = ({ text, maxLength, children, ...rest }) => {
  const displayText =
    maxLength && text && text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;

  let content = displayText;

  if (children !== undefined && children !== null) {
    if (React.isValidElement(children)) {
      content = React.cloneElement(children, {}, displayText);
    } else {
      // If children is not a valid React element (e.g., a string),
      // just render the truncated text directly without warning.
      content = displayText;
    }
  }

  return (
    <TruncatedContainer data-tooltip={text} title={text} {...rest}>
      {content}
    </TruncatedContainer>
  );
};

export default TruncatedText;
